import { motion } from "framer-motion"
import { Mail } from "lucide-react"

const email = "dmitrij.tjumenzew@bookay-buecher.de"

export function Contact() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-gradient-to-tr from-black/10 to-transparent blur-3xl" />
        <div className="absolute -right-24 top-32 h-72 w-72 rounded-full bg-gradient-to-tr from-gray-400/20 to-transparent blur-3xl" />
      </div>

      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto text-center space-y-6">
          <a
            href={`mailto:${email}`}
            className="inline-flex items-center gap-2 rounded-2xl border bg-white/40 backdrop-blur px-6 py-3 font-medium hover:bg-white/60 transition">
            <Mail className="h-4 w-4" />
            {email}
          </a>

          <p className="text-sm text-gray-500">Wir antworten in der Regel innerhalb weniger Tage.</p>
        </motion.div>
      </div>
    </section>
  )
}
